/**
 * Encode any string params to UTF-8.
 * @param params
 * @returns {*|{}}
 */
export function encodeUTF8Params(params) {
    if (!params) return params;

    return _traverseAndTransform(params, (value) => {
        if (typeof value === 'string') {
            return encodeURIComponent(value);
        }
        return value;
    });
}

/**
 * Decode any UTF-8 encoded string params.
 * @param data
 * @returns {*|{}}
 */
export function decodeUTF8Response(data) {
    return _traverseAndTransform(data, (value) => {
        if (typeof value === 'string') {
            try {
                return decodeURIComponent(value);
            } catch (e) {
                console.warn('[decodeUTF8Response] Failed to decode value:', e);
                return value;
            }
        }
        return value;
    });
}

/**
 * Traverse an object and apply a transformer function to each value.
 * @param data
 * @param transformer
 * @returns {{}|*}
 * @private
 */
function _traverseAndTransform(data, transformer) {
    if (Array.isArray(data)) {
        return data.map(item => _traverseAndTransform(item, transformer));
    }
    if (data && typeof data === 'object') {
        const result = {};
        for (const [key, value] of Object.entries(data)) {
            result[key] = _traverseAndTransform(value, transformer);
        }
        return result;
    }
    return transformer(data);
}
